module.exports = __webpack_public_path__ + "static/img/contect_2.29f24b57.jpg";